export default __webpack_public_path__ + "static/media/check.e8809530.svg";